import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
    profilePhoto: '',
};

export const profileSlice = createSlice({
    name: 'profile-slice',
    initialState,
    reducers: {
        setProfilePhoto: (state, action) => {
            state.profilePhoto = action.payload;
        },
    },
});

export const { setProfilePhoto } = profileSlice.actions;
export default profileSlice.reducer;
